import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Cart } from '@cargos/sprintpay-models';
import { Subject, takeUntil } from 'rxjs';
import { CartBillService } from '../../services';

@Component({
    standalone: true,
    selector: 'app-continue-button',
    templateUrl: './continue-button.component.html',
    styleUrls: ['./continue-button.component.scss'],
    imports: [MatButtonModule],
})
export class ContinueButtonComponent implements OnInit, OnDestroy {
    public cartBill: Cart;
    private readonly unsubscribe$: Subject<void>;
    private readonly router = inject(Router);
    private readonly cartBillService = inject(CartBillService);

    constructor() {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeCart();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    goToCart(): void {
        this.router.navigate([`/cart`]);
    }

    subscribeCart(): void {
        this.cartBillService
            .getCartBill$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((cart) => {
                this.cartBill = cart;
            });
    }
}
